module.exports = __webpack_public_path__ + "static/media/instagram-footer.2e8249e0.svg";